// extracted by mini-css-extract-plugin
export var borderRadius = "_e5-4";
export var large = "_e5-3";
export var logoContainer = "_e5-0";
export var nameLogo = "_e5-2";
export var small = "_e5-1";